import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>(() => ({
  cardContent: {
    padding: 0,
  },
  cardActions: {
    marginTop: "12px",
  },
  formControl: {
    display: "flex",
    marginBottom: "8px",
  },
}));
